import GridViewIcon from '@mui/icons-material/GridView';
import TableRowsIcon from '@mui/icons-material/TableRows';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import { Sxable } from 'library/types';

export type DisplayAlignment = 'card' | 'grid';

interface GridOrCardToggleButtonProps extends Sxable {
	id?: string;
	value: DisplayAlignment;
	onChange: (value: DisplayAlignment) => void;
}
export const GridOrCardToggleButton = ({
	id,
	value,
	onChange,
	sx = [],
}: GridOrCardToggleButtonProps): React.JSX.Element => (
	<ToggleButtonGroup
		id={id}
		sx={[...(Array.isArray(sx) ? sx : [sx])]}
		value={value}
		exclusive
		onChange={(_, changedValue) => onChange(changedValue)}
		size="small"
		aria-label="view">
		<ToggleButton value="grid" aria-label="table view">
			<TableRowsIcon />
		</ToggleButton>
		<ToggleButton value="card" aria-label="grid view">
			<GridViewIcon />
		</ToggleButton>
	</ToggleButtonGroup>
);
